import { render, staticRenderFns } from "./guidancePaper.vue?vue&type=template&id=d6c6ab1a&scoped=true&"
import script from "./guidancePaper.vue?vue&type=script&lang=js&"
export * from "./guidancePaper.vue?vue&type=script&lang=js&"
import style0 from "./guidancePaper.vue?vue&type=style&index=0&id=d6c6ab1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c6ab1a",
  null
  
)

export default component.exports